import { render, staticRenderFns } from "./ViewContent.vue?vue&type=template&id=366583f2&"
import script from "./ViewContent.vue?vue&type=script&lang=js&"
export * from "./ViewContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports